import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import config from 'react-global-configuration';
import { push } from 'connected-react-router';
import {
  Container,
  Image,
} from '@uncinc/uncinc-react-kitchen-sink';

import AutoComplete from '../../../components/AutoComplete';

import { WysiwygField } from '../../../components';

import './style.scss';
import { EN_LOCATIONS_URL, NL_LOCATIONS_URL } from '../../../config/constants';

const TARGET_LOCATION = 'location';
const TARGET_VACANCIES_PATH = 'vacatures';

const ParagraphSearch = ({ id, entity, dispatch }) => {
  const { t } = useTranslation();
  const title = entity.getIn(['field_title', 0, 'value']);
  const body = entity.getIn(['field_text', 0, 'processed']);
  const target = entity.getIn(['field_target', 0, 'value']);
  const image = entity.getIn(['field_media_item', 0, 'styles', 'location_search']);
  const currentLanguage = useSelector((state) => state.getIn(['ui', 'language'], 'nl'));
  const locationsUrl = currentLanguage === 'nl' ? NL_LOCATIONS_URL : EN_LOCATIONS_URL;
  const redirectPath = target === TARGET_LOCATION ? locationsUrl : TARGET_VACANCIES_PATH;

  return (
    <Container id={id} className={`ParagraphSearch ${!image ? 'greyed' : ''}`}>
      <div className="row">
        {image && (
          <div className="col-12 col-md-5 img-holder">
            <Image src={image} />
          </div>
        )}
        <div className={`col-12 ${image ? 'offset-md-1 col-md-6' : ''}`}>
          <div className="ParagraphSearch__inner ">
            <div className="ParagraphSearch__inner__title">
              <h2>{title}</h2>
            </div>
            <div className="ParagraphSearch__inner__body">
              <WysiwygField
                property="schema:text"
                className="ParagraphText__body"
                html={body}
              />
            </div>
            <div className="ParagraphSearch__inner__autocomplete">
              <AutoComplete
                isCta
                label="filters.search_bounds.label_short"
                callback={(item) => {
                  dispatch(push(`/${currentLanguage}/${redirectPath}?lat=${item.lat}&long=${item.lon}&input=${item.name}`));
                }}
                onEnterTakeFirstResult
              />
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ParagraphSearch;
